/**
 * Window Shim
 *
 * Centralizes ad-hoc global window state used across legacy UI flows.
 * Preferred alternatives:
 * - Auth state: useAuth() from lib/auth.tsx
 * - Router/nav: TanStack Router + container state
 *
 * This shim remains browser-only.
 */

const getStorage = () => {
  if (typeof window === 'undefined') {
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    } as unknown as Storage;
  }

  return window.sessionStorage;
};

export const sessionStorageGet = (key: string): string | null => {
  try {
    return getStorage().getItem(key);
  } catch {
    return null;
  }
};

export const sessionStorageSet = (key: string, value: string): void => {
  try {
    getStorage().setItem(key, value);
  } catch {
    // no-op
  }
};

export const sessionStorageRemove = (key: string): void => {
  try {
    getStorage().removeItem(key);
  } catch {
    // no-op
  }
};

export const parseSessionToken = () => {
  const raw = sessionStorageGet('token');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
